import { useFeatureFlags } from 'utils/features';

export default function useSafetyIncidentsEnabled() {
  return useFeatureFlags('SAFETY_INCIDENTS');
}
